import { ProcessOperationType } from 'types/Process';
import { ProcessExcelConfig } from './types';

/** Config Excel y payload para CAPITAL_CALL (columnas según plantilla descargada) */
// eslint-disable-next-line import/prefer-default-export
export const CAPITAL_CALL_CONFIG: ProcessExcelConfig = {
  operationType: ProcessOperationType.CAPITAL_CALL,
  promotionColIndex: 0,
  accountNameColIndex: 2,
  payloadColumns: {
    investmentAccountId: { colIndex: 1, type: 'string', label: 'Cuenta de inversión' },
    amount: { colIndex: 13, type: 'number', label: 'Capital solicitado' },
    paymentDate: { colIndex: 15, type: 'date', label: 'Fecha límite pago' },
    exercise: { colIndex: 4, type: 'string', label: 'Ejercicio' },
    percentageOfSubscribedCapital: {
      colIndex: 16,
      type: 'number',
      label: 'Porcentaje capital suscrito',
    },
    BIC: {
      colIndex: 18,
      type: 'string',
      label: 'BIC',
      optional: true,
      minLength: 5,
    },
    IBAN: {
      colIndex: 19,
      type: 'string',
      label: 'IBAN',
      optional: true,
      minLength: 15,
      maxLength: 34,
      stripSpaces: true,
      alphanumericOnly: true,
    },
    Banco: {
      colIndex: 20,
      type: 'string',
      label: 'Banco',
      optional: true,
    },
  },
};
